import { ChatConversacion, SolicitudTipo } from '../interfaces/chat.interface';

export function chatTienePendiente(conversacion: Pick<ChatConversacion, 'solicitudes'>): boolean {
  return conversacion.solicitudes.length > 0;
}

export function chatTieneSolicitud(
  conversacion: Pick<ChatConversacion, 'solicitudes'>,
  tipo: SolicitudTipo,
): boolean {
  return conversacion.solicitudes.some((solicitud) => solicitud.tipo === tipo);
}
